import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromRoot from '../../../app/state/app.selectors';
import * as fromFormStatus from './form-status.reducers';

export interface FormStatusState {
  stateData: fromFormStatus.State;
}

export interface State extends fromRoot.AppState {
  formStatus: FormStatusState;
}

export const reducers = {
  stateData: fromFormStatus.reducer
};

export const selectFormStatusState = createFeatureSelector<FormStatusState>('formStatus');

export const selectFormStatusStateData = createSelector(selectFormStatusState, (state: FormStatusState) => state.stateData);


export const getFormStatusScreenError = createSelector(selectFormStatusStateData, fromFormStatus.getError);

export const getFormStatusScreenPending = createSelector(selectFormStatusStateData, fromFormStatus.getPending);


export const getClosedCGData = createSelector(selectFormStatusStateData, fromFormStatus.getClosedCGData);

export const getOpenCGData = createSelector(selectFormStatusStateData, fromFormStatus.getOpenCGData);


export const getOpenPPData = createSelector(selectFormStatusStateData, fromFormStatus.getOpenPPData);

export const getClosedPPData = createSelector(selectFormStatusStateData, fromFormStatus.getClosedPPData);


export const getClosedESData = createSelector(selectFormStatusStateData, fromFormStatus.getClosedESData);

export const getOpenESData = createSelector(selectFormStatusStateData, fromFormStatus.getOpenESData);




// export const getOpenCIData = createSelector(selectFormStatusStateData, fromFormStatus.getOpenCIData);

// export const getOpenFOData = createSelector(selectFormStatusStateData, fromFormStatus.getOpenFOData);

// export const getClosedCIData = createSelector(selectFormStatusStateData, fromFormStatus.getClosedCIData);

// export const getClosedFOData = createSelector(selectFormStatusStateData, fromFormStatus.getClosedFOData);